// directives/body-scroll-lock.js
const scrollLock = {
  inserted (el, binding) {
    const vm = binding.instance
    if (!vm) return
    vm.$watch(
      () => binding.value,
      (newVal) => {
        if (newVal) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop
          const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth

          vm._scrollLockData = { scrollTop, scrollbarWidth }

          document.body.style.cssText = `
            position: fixed;
            top: -${scrollTop}px;
            overflow-y: scroll;
            width: 100%;
            padding-right: ${scrollbarWidth}px;
          `
        } else {
          document.body.style.cssText = ''
          if (vm._scrollLockData && typeof vm._scrollLockData.scrollTop !== 'undefined') {
            window.scrollTo(0, vm._scrollLockData.scrollTop)
          } else {
            window.scrollTo(0, 0)
          }
          // window.scrollTo(0, vm._scrollLockData ?.scrollTop || 0)
        }
      }
    )
  },
  unbind (el, binding) {
    if (binding.value && binding.instance && binding.instance._scrollLockData) {
      document.body.style.cssText = ''
      window.scrollTo(0, binding.instance._scrollLockData.scrollTop)
    }
  }
}
export default scrollLock



// WEBPACK FOOTER //
// ./src/assets/js/body-scroll-lock.js